export * from './theme.component';

export const ThemeTemplate = require("./theme.component.html");
